import ReactOnRails from 'react-on-rails';
import * as components from './src/components';

ReactOnRails.register(components);
